
    import { Component, Vue, Watch } from 'vue-property-decorator'
    let dl_1 = require('./../../../assets/imgs/dl_1.png'),
        dl_2 = require('./../../../assets/imgs/dl_2.png'),
        dl_3 = require('./../../../assets/imgs/dl_3.png'),
        dl_4 = require('./../../../assets/imgs/dl_4.png'),
        dl_5 = require('./../../../assets/imgs/dl_5.png'),
        dl_6 = require('./../../../assets/imgs/dl_6.png'),
        dl_7 = require('./../../../assets/imgs/dl_7.png');
    @Component({
        name: 'DashLearningeffect'
    })
    export default class DashLearningeffect extends Vue {
        private stepItemList: Array<any> = [
            { icon: dl_1, text: '课前小测', info: '利用课前20分钟对上节课知识要点进行复习' },
            { icon: dl_2, text: '知识讲解', info: '以例题讲解试做的方式教授本节课的知识点' },
            { icon: dl_3, text: '错题订正', info: '利用课间对课前测的错题进行讲解和订正' },
            { icon: dl_4, text: '课堂直播', info: '由助教老师在班级群图文直播上课内容' },
            { icon: dl_5, text: '课后小测', info: '利用课后20分钟对课上知识要点进行练习' },
            { icon: dl_6, text: '作业巩固', info: '课后对本节课的知识点进行强化和练习' },
            { icon: dl_7, text: '课程总结', info: '通过大数据为每一位学生生成专属成绩报告' },
        ]
    }
